// image info -->
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    IRViewerKeys: function() {
        return _IRViewerEnum.default;
    },
    ImageInfoKeys: function() {
        return _ImageInfoEnum.default;
    },
    InfoTableKeys: function() {
        return _InfoTableEnum.default;
    },
    KonvaShapes: function() {
        return _KonvaShapesEnum.default;
    },
    KonvaToRendererShapes: function() {
        return _KonvaToRendererShapesEnum.default;
    },
    MarkerPrefix: function() {
        return _MarkerPrefixEnum.default;
    },
    PaletteDefault: function() {
        return _PaletteDefaultsEnum.default;
    },
    RendererCoordinates: function() {
        return _RendererCoordinatesEnum.default;
    },
    RendererToKonvaShapes: function() {
        return _RendererToKonvaShapesEnum.default;
    },
    ValidSettings: function() {
        return _SettingsEnum.default;
    }
});
const _ImageInfoEnum = /*#__PURE__*/ _interop_require_default(require("./ImageInfoEnum.js"));
const _IRViewerEnum = /*#__PURE__*/ _interop_require_default(require("./IRViewerEnum.js"));
const _SettingsEnum = /*#__PURE__*/ _interop_require_default(require("./SettingsEnum.js"));
const _InfoTableEnum = /*#__PURE__*/ _interop_require_default(require("./InfoTableEnum.js"));
const _PaletteDefaultsEnum = /*#__PURE__*/ _interop_require_default(require("./PaletteDefaultsEnum.js"));
const _MarkerPrefixEnum = /*#__PURE__*/ _interop_require_default(require("./MarkerPrefixEnum.js"));
const _KonvaShapesEnum = /*#__PURE__*/ _interop_require_default(require("./KonvaShapesEnum.js"));
const _KonvaToRendererShapesEnum = /*#__PURE__*/ _interop_require_default(require("./KonvaToRendererShapesEnum.js"));
const _RendererToKonvaShapesEnum = /*#__PURE__*/ _interop_require_default(require("./RendererToKonvaShapesEnum.js"));
const _RendererCoordinatesEnum = /*#__PURE__*/ _interop_require_default(require("./RendererCoordinatesEnum.js"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
